import React, {useState, createContext, useEffect} from 'react';
import './index.css';
import theme from './theme';

import Home from './pages/Home';
import Login from './pages/login';
import RegistFond from './pages/register-fond';
import RegistDepense from './pages/register-depense';
import Cloture from './pages/cloture';
import Rapport from './pages/rapport';
import GrandLivre from './Components/journaux/grand-livre';
import JrnDon from './Components/journaux/jrn-don';
import JrnVers from './Components/journaux/jrn-versement';
import DonatorManager from './pages/donator-manager';
import {createBrowserRouter, RouterProvider} from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CompteManager from './pages/compte-manager';
import JrnDepenses from './Components/journaux/jrn-depense';
import JrnPetiteCaisse from './Components/journaux/jrn-pc';
import JrnDepartement from './Components/journaux/jrn-department';
import JrnComptes from './Components/journaux/jrn-comptes';
import Users from './AdmComponents/users';
import Eglises from './AdmComponents/eglises';
import MdpForm from './pages/reinit-mdp';
import VersementsManager from './AdmComponents/versement-cash';
import VersementsBanqueManager from './AdmComponents/versement-banque';
import CaisseCenter from './AdmComponents/caisse-center';
import CaisseRecette from './AdmComponents/caisse-recette';
import VerseForm from './pages/verse-form';
import DBManager from './AdmComponents/db-manager';
import EBPexport from './AdmComponents/EBP-export';
import AlerteManager from './AdmPages/alerte-manager';
import RegionsManager from './AdmPages/regions-manager';

import Billets from './pages/Billets';
import Commandes from './pages/Commandes';
import EventsAndProjects from './pages/EventAndProjects';
import { API } from './conf';

//dark mode et proposition de palette de couleur(en fonction du mode)

const agent = sessionStorage.getItem('user') ? JSON.parse(sessionStorage.getItem('user')) : {}

export const Context = createContext()

const routes = [
  {path:"/recettes/enregistrement-des-fonds", element: <RegistFond/>},
  {path:"/versements/enregistrement", element: <VerseForm/>},
  {path:"/depenses/enregistrement", element: <RegistDepense/>},

  {path:"/cloture", element: <Cloture/>},
  {path:"/rapports", element: <Rapport/>},

  {path:"/journal/global", element: <GrandLivre/>},
  {path:"/journal/dons", element: <JrnDon/>},
  {path:"/journal/versements", element: <JrnVers/>},
  {path:"/journal/depenses", element: <JrnDepenses/>},
  {path:"/journal/petite-caisse", element: <JrnPetiteCaisse/>},
  {path:"/journal/départements", element: <JrnDepartement/>},
  {path:"/comptes/consultation", element: <JrnComptes/>},

  {path:"/comptes", element: <CompteManager/>},
  {path:"/donateurs", element: <DonatorManager/>},
  {path:"/users", element: <Users/>},
  {path:"/eglises", element: <Eglises/>},
  {path:"/regions", element: <RegionsManager/>},
  {path:"/dada-base", element: <DBManager/>},

  {path:"/export/ebp", element: <EBPexport/>},
  {path:"/alertes", element: <AlerteManager/>},

  {path:"/set-password/:token", element: <MdpForm/>},

  {path:"/caisse/versements", element: <VersementsManager/>},
  {path:"/caisse", element: <CaisseCenter/>},
  {path:"/caisse/recette", element: <CaisseRecette/>},

  {path:"/versements/banque", element: <VersementsBanqueManager/>},

  //Esdras management
  {path:"/esdras/commandes", element: <Commandes/>},
  {path:"/esdras/billets", element: <Billets/>},
  {path:"/esdras/projects", element: <EventsAndProjects/>}
]

const unlogged_router = createBrowserRouter([
    {path:"/", element: <Login/>},
    {path:"/set-password/:token", element: <MdpForm/>},
    {path:"*", element: <Login/>}
  ])

export default function App() {
  const user = JSON.parse(sessionStorage.getItem('user'))
  const [isConnect, setConnect] = useState(sessionStorage.getItem("token") ? true : false)
  const [eglise, seteglise] = useState(sessionStorage.getItem('eglise')?JSON.parse(sessionStorage.getItem('eglise')):'')
  const [region, setRegion] = useState(sessionStorage.getItem('region')?JSON.parse(sessionStorage.getItem('region')):'')

  function updateConnect(newValue) {
    setConnect(newValue)
  }

  function setEglise(value) {
    seteglise(value)
    sessionStorage.setItem('eglise', value==='indifferent' ? sessionStorage.getItem('original_eglise') : JSON.stringify(value))
  }

  useEffect(()=>{
    if(isConnect && user && (user.organisation!==eglise?.number || region==='')){
      const query = new URLSearchParams({number: user.organisation}).toString();
      fetch(API.concat('/eglise?'+query), {
        method: 'GET',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          'authorization': 'Bearer ' + sessionStorage.getItem('token')
      }}).then(async response => {
        const token = response.headers.get('x-auth-token');
        if (response.status === 401) {
          sessionStorage.clear();
          updateConnect(false);
        } else {
          if (token && token !== sessionStorage.getItem('token') && token !== '') {
            sessionStorage.setItem('token', response.headers.get('x-auth-token'));
          }
          if (response.status === 200) {
            const json = await response.json();
            setRegion(json.region[0]);
            sessionStorage.setItem('region', JSON.stringify(json.region[0]));
          }
        }
      })
    }
  },[user])

  return(
    <Context.Provider value={{ isConnect, updateConnect, eglise, setEglise, region, setRegion}} >
      <ThemeProvider theme={theme}>
        <React.StrictMode>
          <RouterProvider router={isConnect ? createBrowserRouter([{path:"/", element: <Home/>}, ...routes.filter(route=> user?.access.includes(route.path)||(user?.access.includes('/caisse')&&/^\/caisse\/.+$/.test(route.path))), {path:"*", element: <Home/>}]): unlogged_router}/>
        </React.StrictMode>
      </ThemeProvider>
    </Context.Provider>
  );

}